import { Box, Container } from '@mui/material';
import React, { FC } from 'react';
import titleImage from '../../../../assets/images/programm/ProgrammTitle.png';
import HeroHeaderSection from '../../../../components/ui-component/hero-header/HeroHeader';
import LoadingBackdrop from '../../../../components/ui-component/loading/LoadingBackdrop';
import { useFetchFoerderProgramm } from '../../../../hooks/FetchFoerderProgramm';
import FoerderProgrammGrid from './structure/FoerdProgrammGrid';

const FoerderProgrammeView: FC = () => {
	const { loading, data, error } = useFetchFoerderProgramm();

	if (error) console.error('ERROR: Fetching Förderprogramme ', error);
	if (loading) return <LoadingBackdrop />;
	return (
		<Box sx={{ mb: '2rem' }}>
			<HeroHeaderSection
				title='Innovation vorhanden – Förderung gesucht?'
				description='Lassen Sie sich Ihre Projektausgaben fördern. Finden Sie hier das Förderprogramm, das zu Ihren Projektideen passt, und stellen Sie gleich hier Ihren Antrag auf Förderung. Einfach digital.'
				backgroundImage={titleImage}
			/>
			<Container>
				<Box sx={{ mt: '2rem' }}>
					<FoerderProgrammGrid {...{ data }} />
				</Box>
			</Container>
		</Box>
	);
};

export default FoerderProgrammeView;
